export interface ValidateListingResponse {
    success: boolean;
    description: string;
}
